import React, { useEffect, useState } from 'react';
import CloseButton from './CloseButton';

export default function ModalShell({
  onClose,
  children,
  width = 520,
  maxWidth = '98vw',
  height = null,
  maxHeight = '96vh',
  overlayZIndex = 2000,
  panelZIndex = 10000,
}) {
  const [panelWidth, setPanelWidth] = useState(width);

  useEffect(() => {
    function handleResize() {
      // Keep width responsive similar to other panels in the app.
      const w = Math.min(window.innerWidth - 32, typeof width === 'number' ? width : 520);
      setPanelWidth(Math.max(260, w));
    }

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [width]);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.3)',
        zIndex: overlayZIndex,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 16,
          padding: '24px 12px 18px 12px',
          boxShadow: '0 2px 18px rgba(0,0,0,0.22)',
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
          minWidth: 0,
          width: typeof width === 'number' ? `${panelWidth}px` : width,
          maxWidth,
          minHeight: 0,
          height: height ? (typeof height === 'number' ? `${height}px` : height) : 'auto',
          maxHeight,
          overflow: 'auto',
          zIndex: panelZIndex,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {typeof onClose === 'function' && (
          <CloseButton
            onClick={onClose}
            position="absolute"
            top={10}
            right={10}
            zIndex={panelZIndex + 1}
          />
        )}

        {children}
      </div>
    </div>
  );
}
